/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorRoute extends Route {
  queryParams = {
    interval: { refreshModel: false },
  };

  analytics = {
    section: 'standalone',
    place: 'monitor',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorRoute, {
  overrideRenderTemplate: false,
});
